import TeachersActions from './actions'
import {findIndex} from 'lodash'

const initialState = {
  isFetching: false,
  isError: false,
  messageError: null,
  items: [],
  confirmTeacherAccount: {
    isFetching: false,
    isError: false,
    messageError: null
  }
}

function TeachersReducer (state = initialState, action) {
  switch (action.type) {
    case TeachersActions.TEACHERS_FETCH_REQUEST:
      return {
        ...state,
        isFetching: true,
        isError: false,
        messageError: null
      }
    case TeachersActions.TEACHERS_FETCH_SUCCESS:
      return {
        ...state,
        items: action.payload.data,
        isFetching: false,
        isError: false,
        messageError: null
      }
    case TeachersActions.TEACHERS_FETCH_ERROR:
      return {
        ...state,
        isFetching: false,
        isError: true,
        messageError: action.payload
      }
    case TeachersActions.CONFIRM_TEACHER_ACCOUNT_REQUEST:
      return {
        ...state,
        confirmTeacherAccount: {
          ...state.confirmTeacherAccount,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case TeachersActions.CONFIRM_TEACHER_ACCOUNT_SUCCESS:
      const indexRemove = findIndex(state.items, (item) => (
        item.id === action.payload.id)
      )
      return {
        ...state,
        items: [
          ...state.items.slice(0, +indexRemove),
          ...state.items.slice(+indexRemove + 1)
        ],
        confirmTeacherAccount: {
          ...state.confirmTeacherAccount,
          isFetching: false,
          isError: false,
          messageError: null
        }
      }
    case TeachersActions.CONFIRM_TEACHER_ACCOUNT_ERROR:
      return {
        ...state,
        confirmTeacherAccount: {
          ...state.confirmTeacherAccount,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    default:
      return state
  }
}

export default TeachersReducer



// WEBPACK FOOTER //
// ./src/modules/teachers/reducers.js